import { useLoginFormStore, } from "../../../../../store/loginFormStore.ts";

export function usePassportFormState() {
  const passportType = useLoginFormStore(state => state.passportType,);
  const passportNumber = useLoginFormStore(state => state.passportNumber,);
  const formState = useLoginFormStore(state => state.formState,);

  const setPassportType = useLoginFormStore(state => state.setPassportType,);
  const setPassportNumber = useLoginFormStore(state => state.setPassportNumber,);
  const setFormState = useLoginFormStore(state => state.setFormState,);

  const getEscapedPassportNumber = useLoginFormStore(state => state.getEscapedPassportNumber,);
  const errorMessageOption = useLoginFormStore(state => state.errorMessageOption,);
  const errorMessageText = useLoginFormStore(state => state.errorMessageText,);
  const setOptionError = useLoginFormStore(state => state.setOptionError,);
  const setTextError = useLoginFormStore(state => state.setTextError,);
  const clearForm = useLoginFormStore(state => state.clearForm,);

  return {
    passportType,
    passportNumber,
    formState,
    getEscapedPassportNumber,
    errorMessageOption,
    errorMessageText,
    setPassportType,
    setPassportNumber,
    setFormState,
    setOptionError,
    setTextError,
    clearForm,
  };
}
